import MuiAppBar, { AppBarProps as Props } from '@material-ui/core/AppBar'
import MuiToolbar from '@material-ui/core/Toolbar'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import * as React from 'react'

export type AppBarProps = {
  children: React.ReactNode
} & Props

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1
    }
  })
)

const AppBar: React.FC<AppBarProps> = (props) => {
  const classes = useStyles()
  const { children, ...rest } = props
  return (
    <MuiAppBar className={classes.root} {...rest}>
      <MuiToolbar>{children}</MuiToolbar>
    </MuiAppBar>
  )
}

export default AppBar
